/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import Service, { service } from '@ember/service';
// External imports
import LincStaffAccess from '@linc-technologies/linced-common/enums/roles/linc-staff-access';
export default class RolesService extends Service {
  @service
  session;

  // has determines whether the current user has the specified role.
  has(role) {
    return this.session?.person?.roles?.includes(role) ?? false;
  }

  // Admin site roles to access certain sections of the menu
  @computed('session.person.roles.[]')
  get hasAPIActivationAccess() {
    return this.has(LincStaffAccess.API_ACTIVATION);
  }

  // hasFullRole allows the person to access all sections of the menu
  @computed('session.person.roles.[]')
  get hasFullAccessRole() {
    return this.has(LincStaffAccess.FULL_ACCESS);
  }

  // hasManageRole allows the person to access the Hero Management section of the menu
  @computed('session.person.roles.[]')
  get hasManageRole() {
    return this.has(LincStaffAccess.HERO_MANAGEMENT);
  }

  // hasCommunicationRole allows the person to access the Hero Communication section of the menu
  @computed('session.person.roles.[]')
  get hasCommunicationRole() {
    return this.has(LincStaffAccess.HERO_COMMUNICATION);
  }

  // hasSHManageRole allows the person to access the SuperHero Management section of the menu
  @computed('session.person.roles.[]')
  get hasSHManageRole() {
    return this.has(LincStaffAccess.SUPERHERO_MANAGEMENT);
  }
}
